import ServicioService from 'src/modules/servicio/servicioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'SERVICIO_VIEW';

const servicioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: servicioViewActions.FIND_STARTED,
      });

      const record = await ServicioService.find(id);

      dispatch({
        type: servicioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: servicioViewActions.FIND_ERROR,
      });

      getHistory().push('/servicio');
    }
  },
};

export default servicioViewActions;
